import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Property} from "../model/property";
import {Order} from "../model/order";
import {PropertyStatistics} from "../model/property-statistics";
import {ViewName} from "../model/viewname";

@Injectable({
  providedIn: 'root'
})
export class PropertyService {

  constructor(private httpClient: HttpClient) { }

  getPropertyById(propertyId, viewName: ViewName | null = null,orders: Order[] = []): Observable<Property> {
    let searchedProperty;
    if (orders)
      orders.forEach(order => {
        return order.properties.forEach(property => {
          if (propertyId === property.id)
            searchedProperty = property;
        });
      });
    if (!searchedProperty){
        let url = "/api/property/" + propertyId;

        if(viewName){
            url += `?oView=${viewName}`;
        }
        return this.httpClient.get<Property>(url);
    }
    else
      return Observable.of(searchedProperty);
  }

  findPropertiesBySearchTerm(searchTerm: string, options = {}): Observable<Property[]> {
    return this.httpClient.get<Property[]>("/api/property/search?query=" + searchTerm, options);
  }

  public getChildlessPropertiesByOrder(orderId: string, options = {}): Observable<Property[]>{
      return this.httpClient.get<Property[]>("/api/properties/orders/" + orderId + "?view=childlessView", options);
  }

    /**
     * Get an array of property statistics for all properties of an order.
     * The property statistics contains information that are important but are not part of childless properties e.g. document count, document file count, total file size etc.
     *
     * @param orderId Id of an order for which the property statistics of all properties should be gotten
     * @param options HttpOptions
     * @return Array with all property statistics for all properties of an order
     */
  public getPropertyStatisticsForOrderProperties(orderId: string, options:{}={}): Observable<PropertyStatistics[]>{
      return this.httpClient.get<PropertyStatistics[]>("/api/orders/" +orderId + "/properties/statistics", options);
  }

    /**
     * Get PropertyStatistics for a specific property
     *
     * @param propertyId Id of the property for which the statistics should be gotten
     * @param options HttpOptions
     */
  public getPropertyStatistics(propertyId: string, options:{}={}): Observable<PropertyStatistics>{
      return this.httpClient.get<PropertyStatistics>("/api/properties/" + propertyId + "/statistics", options);
  }

    /**
     * Retrieves the uploaded file for a specific customer interaction response.
     * The file is retrieved as base64 encoded byte[]
     *
     * @param propertyId Id of the property which contains the associated customer interaction
     * @param customerInteractionResponseId Id of the customer interaction response for which the file should be gotten.
     */
  public getCustomerInteractionResponsePdf(propertyId: string, customerInteractionResponseId: string): Observable<string>{
      return this.httpClient.get(`/api/properties/${propertyId}/customer-interaction-responses/${customerInteractionResponseId}/pdf`, { responseType: "text" });
  }

}
